import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext();
export const useCart = () => useContext(CartContext);

const keyOf = (i) => i.key || (i.variant_id ? `${i.id}::${i.variant_id}` : i.id);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = JSON.parse(localStorage.getItem("afrigate_cart") || "[]");
      return raw.map((i) => ({ ...i, key: keyOf(i) }));
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("afrigate_cart", JSON.stringify(items));
  }, [items]);

  // add(product, qty, variant?) — variant: { id, name, price_gbp, weight_kg, image }
  const add = (product, qty = 1, variant = null) => {
    const ratio = product.delivered_gbp ? (product.delivered_ghs || 0) / product.delivered_gbp : 19.5;
    const gbp = variant && variant.price_gbp != null ? Number(variant.price_gbp) : product.delivered_gbp;
    const ghs = variant && variant.price_gbp != null ? Math.round(Number(variant.price_gbp) * ratio) : product.delivered_ghs;
    const vId = variant?.id || "";
    const key = vId ? `${product.id}::${vId}` : product.id;
    setItems((prev) => {
      const found = prev.find((i) => keyOf(i) === key);
      if (found) return prev.map((i) => (keyOf(i) === key ? { ...i, quantity: i.quantity + qty } : i));
      return [...prev, {
        key, id: product.id, variant_id: vId, variant_name: variant?.name || "",
        name: variant?.name ? `${product.name} — ${variant.name}` : product.name,
        image: variant?.image || product.image,
        delivered_gbp: gbp, delivered_ghs: ghs, quantity: qty,
      }];
    });
  };

  const remove = (key) => setItems((prev) => prev.filter((i) => keyOf(i) !== key));
  const setQty = (key, qty) =>
    setItems((prev) => prev.map((i) => (keyOf(i) === key ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const totalGbp = items.reduce((s, i) => s + i.delivered_gbp * i.quantity, 0);
  const totalGhs = items.reduce((s, i) => s + i.delivered_ghs * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, totalGbp, totalGhs, count }}>
      {children}
    </CartContext.Provider>
  );
}
